/**
 * Category Statistics Card.
 * Displays statistics for categorical columns.
 */

import React from 'react';
import type { CategoryStats } from '@excel-ai-studio/shared';
import { ResultCard } from '../common/ResultCard';

interface CategoryStatsCardProps {
  readonly stats: readonly CategoryStats[];
}

export const CategoryStatsCard: React.FC<CategoryStatsCardProps> = ({ stats }) => {
  if (stats.length === 0) return null;

  return (
    <ResultCard
      title="Statistiques catégorielles"
      variant="analysis"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {stats.map((stat) => (
          <div key={stat.column} style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '12px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
              {stat.column} ({stat.distinctCount} catégories)
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px' }}>
              {stat.topValues.map((value, idx) => (
                <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>{value.value}</span>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <div
                      style={{
                        width: '100px',
                        height: '6px',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '3px',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: `${value.percentage}%`,
                          height: '100%',
                          backgroundColor: '#0078d4',
                        }}
                      />
                    </div>
                    <span style={{ color: '#666', minWidth: '40px', textAlign: 'right' }}>
                      {value.percentage.toFixed(1)}%
                    </span>
                  </div>
                </div>
              ))}
              {stat.nullCount > 0 && (
                <div style={{ color: '#d13438', fontSize: '12px', marginTop: '4px' }}>
                  {stat.nullCount} valeurs nulles
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </ResultCard>
  );
};
